// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { CurrentUserAccountInfoDTO } from '../models';
import { CurrentUserInfoDTO } from '../models';
import { CustomerDTO } from '../models';
import { MarketingPreferencesDTO } from '../models';
import { OneTimeSessionTokenDTO } from '../models';
import { OrganizationUserDTO } from '../models';
import { SearchUserResultsDTO } from '../models';
import { TenancyAnniversaryWithTenancyDTO } from '../models';
import { TenancyOrderWithTenancyAndOrderCustomersDTO } from '../models';
import { UpdateBetaEnabledDTO } from '../models';
import { UpdateMarketingPreferencesDTO } from '../models';
import { UpdateUserAboutMeDTO } from '../models';
import { UpdateUserAddressHistoryDTO } from '../models';
import { UpdateUserDTO } from '../models';
import { UpdateUserEmailSettingsDTO } from '../models';
import { UserDTO } from '../models';
/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Complete onboarding introduction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeOnboardingIntroduction(options: any = {}): RequestArgs {
            const localVarPath = `/v2/users/me/complete-onboarding-introduction`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a one time session token to transfer a users session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneTimeSessionToken(options: any = {}): RequestArgs {
            const localVarPath = `/v2/users/me/one-time-session-token`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Dismiss new product updates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissNewProductUpdates(options: any = {}): RequestArgs {
            const localVarPath = `/v2/users/me/dismiss-new-product-updates`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Dismiss a user message
         * @param {'featureClaimUploads' | 'marketingMessageSwitchApril2023' | 'minimumRepositPricingMarch2024' | 'partnerDashboardBetaWelcome' | 'partnerEOTChasersWelcome'} messageId Message id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissUserMessage(messageId: 'featureClaimUploads' | 'marketingMessageSwitchApril2023' | 'minimumRepositPricingMarch2024' | 'partnerDashboardBetaWelcome' | 'partnerEOTChasersWelcome', options: any = {}): RequestArgs {
            // verify required parameter 'messageId' is not null or undefined
            if (messageId === null || messageId === undefined) {
                throw new RequiredError('messageId','Required parameter messageId was null or undefined when calling dismissUserMessage.');
            }
            const localVarPath = `/v2/users/me/messages/{messageId}/dismiss`
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a User by id
         * @param {string} id User id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneByID(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling findOneByID.');
            }
            const localVarPath = `/v2/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a customer by userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomer(options: any = {}): RequestArgs {
            const localVarPath = `/v2/users/me/customer`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the authenticated tenant\'s marketing preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketingPreferences(options: any = {}): RequestArgs {
            const localVarPath = `/v2/users/me/marketing-preferences`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a User\'s Organizations
         * @param {string} id User id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationUsers(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getOrganizationUsers.');
            }
            const localVarPath = `/v2/users/{id}/organizations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a users tenancy orders by productId
         * @param {string} productId ProductId to filter tenancy orders by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenancyOrdersByProductId(productId: string, options: any = {}): RequestArgs {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling getTenancyOrdersByProductId.');
            }
            const localVarPath = `/v2/users/me/tenancy-orders`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the authenticated users account info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAccount(options: any = {}): RequestArgs {
            const localVarPath = `/v2/users/me/account`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a users tenancy anniversaries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTenancyAnniversaries(options: any = {}): RequestArgs {
            const localVarPath = `/v2/users/me/tenancy-anniversaries`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the authenticated user info, organizations and reposit stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        me(options: any = {}): RequestArgs {
            const localVarPath = `/v2/users/me`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Send an Agent, Landlord or Tenant a reset password email
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserPassword(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling resetUserPassword.');
            }
            const localVarPath = `/v2/users/{id}/reset-password`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for a User by name or email
         * @param {string} userTypeId User type Id to filter to by
         * @param {number} page Page to start on (defaults to 1)
         * @param {number} size Size of result set to return (defaults to 15)
         * @param {string} [query] Search query
         * @param {string} [sortBy] Sort By to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUser(userTypeId: string, page: number, size: number, query?: string, sortBy?: string, options: any = {}): RequestArgs {
            // verify required parameter 'userTypeId' is not null or undefined
            if (userTypeId === null || userTypeId === undefined) {
                throw new RequiredError('userTypeId','Required parameter userTypeId was null or undefined when calling searchUser.');
            }
            // verify required parameter 'page' is not null or undefined
            if (page === null || page === undefined) {
                throw new RequiredError('page','Required parameter page was null or undefined when calling searchUser.');
            }
            // verify required parameter 'size' is not null or undefined
            if (size === null || size === undefined) {
                throw new RequiredError('size','Required parameter size was null or undefined when calling searchUser.');
            }
            const localVarPath = `/v2/users`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (userTypeId !== undefined) {
                localVarQueryParameter['userTypeId'] = userTypeId;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a users about me via onboarding
         * @param {UpdateUserAboutMeDTO} updateUserAboutMeDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAboutMe(updateUserAboutMeDTO: UpdateUserAboutMeDTO, options: any = {}): RequestArgs {
            // verify required parameter 'updateUserAboutMeDTO' is not null or undefined
            if (updateUserAboutMeDTO === null || updateUserAboutMeDTO === undefined) {
                throw new RequiredError('updateUserAboutMeDTO','Required parameter updateUserAboutMeDTO was null or undefined when calling updateAboutMe.');
            }
            const localVarPath = `/v2/users/me/onboarding/about-me`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateUserAboutMeDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateUserAboutMeDTO !== undefined ? updateUserAboutMeDTO : {}) : (updateUserAboutMeDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a users address history via onboarding
         * @param {UpdateUserAddressHistoryDTO} updateUserAddressHistoryDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAddressHistory(updateUserAddressHistoryDTO: UpdateUserAddressHistoryDTO, options: any = {}): RequestArgs {
            // verify required parameter 'updateUserAddressHistoryDTO' is not null or undefined
            if (updateUserAddressHistoryDTO === null || updateUserAddressHistoryDTO === undefined) {
                throw new RequiredError('updateUserAddressHistoryDTO','Required parameter updateUserAddressHistoryDTO was null or undefined when calling updateAddressHistory.');
            }
            const localVarPath = `/v2/users/me/onboarding/address-history`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateUserAddressHistoryDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateUserAddressHistoryDTO !== undefined ? updateUserAddressHistoryDTO : {}) : (updateUserAddressHistoryDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update beta enabled flag
         * @param {UpdateBetaEnabledDTO} updateBetaEnabledDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBetaEnabled(updateBetaEnabledDTO: UpdateBetaEnabledDTO, options: any = {}): RequestArgs {
            // verify required parameter 'updateBetaEnabledDTO' is not null or undefined
            if (updateBetaEnabledDTO === null || updateBetaEnabledDTO === undefined) {
                throw new RequiredError('updateBetaEnabledDTO','Required parameter updateBetaEnabledDTO was null or undefined when calling updateBetaEnabled.');
            }
            const localVarPath = `/v2/users/me/beta-enabled`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateBetaEnabledDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateBetaEnabledDTO !== undefined ? updateBetaEnabledDTO : {}) : (updateBetaEnabledDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a user\'s email settings
         * @param {UpdateUserEmailSettingsDTO} updateUserEmailSettingsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailSettings(updateUserEmailSettingsDTO: UpdateUserEmailSettingsDTO, options: any = {}): RequestArgs {
            // verify required parameter 'updateUserEmailSettingsDTO' is not null or undefined
            if (updateUserEmailSettingsDTO === null || updateUserEmailSettingsDTO === undefined) {
                throw new RequiredError('updateUserEmailSettingsDTO','Required parameter updateUserEmailSettingsDTO was null or undefined when calling updateEmailSettings.');
            }
            const localVarPath = `/v2/users/me/email-settings`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateUserEmailSettingsDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateUserEmailSettingsDTO !== undefined ? updateUserEmailSettingsDTO : {}) : (updateUserEmailSettingsDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the authenticated tenant\'s marketing preferences
         * @param {UpdateMarketingPreferencesDTO} updateMarketingPreferencesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMarketingPreferences(updateMarketingPreferencesDTO: UpdateMarketingPreferencesDTO, options: any = {}): RequestArgs {
            // verify required parameter 'updateMarketingPreferencesDTO' is not null or undefined
            if (updateMarketingPreferencesDTO === null || updateMarketingPreferencesDTO === undefined) {
                throw new RequiredError('updateMarketingPreferencesDTO','Required parameter updateMarketingPreferencesDTO was null or undefined when calling updateMarketingPreferences.');
            }
            const localVarPath = `/v2/users/me/marketing-preferences`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateMarketingPreferencesDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateMarketingPreferencesDTO !== undefined ? updateMarketingPreferencesDTO : {}) : (updateMarketingPreferencesDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a User
         * @param {string} id 
         * @param {UpdateUserDTO} updateUserDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(id: string, updateUserDTO: UpdateUserDTO, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateUser.');
            }
            // verify required parameter 'updateUserDTO' is not null or undefined
            if (updateUserDTO === null || updateUserDTO === undefined) {
                throw new RequiredError('updateUserDTO','Required parameter updateUserDTO was null or undefined when calling updateUser.');
            }
            const localVarPath = `/v2/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateUserDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateUserDTO !== undefined ? updateUserDTO : {}) : (updateUserDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Complete onboarding introduction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeOnboardingIntroduction(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDTO> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).completeOnboardingIntroduction(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Create a one time session token to transfer a users session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneTimeSessionToken(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OneTimeSessionTokenDTO> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).createOneTimeSessionToken(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Dismiss new product updates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissNewProductUpdates(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDTO> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).dismissNewProductUpdates(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Dismiss a user message
         * @param {'featureClaimUploads' | 'marketingMessageSwitchApril2023' | 'minimumRepositPricingMarch2024' | 'partnerDashboardBetaWelcome' | 'partnerEOTChasersWelcome'} messageId Message id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissUserMessage(messageId: 'featureClaimUploads' | 'marketingMessageSwitchApril2023' | 'minimumRepositPricingMarch2024' | 'partnerDashboardBetaWelcome' | 'partnerEOTChasersWelcome', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDTO> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).dismissUserMessage(messageId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get a User by id
         * @param {string} id User id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneByID(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDTO> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).findOneByID(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get a customer by userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomer(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerDTO> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).getCustomer(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get the authenticated tenant\'s marketing preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketingPreferences(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketingPreferencesDTO> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).getMarketingPreferences(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get a User\'s Organizations
         * @param {string} id User id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationUsers(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationUserDTO>> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).getOrganizationUsers(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get a users tenancy orders by productId
         * @param {string} productId ProductId to filter tenancy orders by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenancyOrdersByProductId(productId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenancyOrderWithTenancyAndOrderCustomersDTO>> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).getTenancyOrdersByProductId(productId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get the authenticated users account info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAccount(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrentUserAccountInfoDTO> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).getUserAccount(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get a users tenancy anniversaries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTenancyAnniversaries(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenancyAnniversaryWithTenancyDTO>> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).getUserTenancyAnniversaries(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get the authenticated user info, organizations and reposit stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        me(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrentUserInfoDTO> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).me(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Send an Agent, Landlord or Tenant a reset password email
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserPassword(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).resetUserPassword(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Search for a User by name or email
         * @param {string} userTypeId User type Id to filter to by
         * @param {number} page Page to start on (defaults to 1)
         * @param {number} size Size of result set to return (defaults to 15)
         * @param {string} [query] Search query
         * @param {string} [sortBy] Sort By to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUser(userTypeId: string, page: number, size: number, query?: string, sortBy?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchUserResultsDTO> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).searchUser(userTypeId, page, size, query, sortBy, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update a users about me via onboarding
         * @param {UpdateUserAboutMeDTO} updateUserAboutMeDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAboutMe(updateUserAboutMeDTO: UpdateUserAboutMeDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDTO> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).updateAboutMe(updateUserAboutMeDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update a users address history via onboarding
         * @param {UpdateUserAddressHistoryDTO} updateUserAddressHistoryDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAddressHistory(updateUserAddressHistoryDTO: UpdateUserAddressHistoryDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDTO> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).updateAddressHistory(updateUserAddressHistoryDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update beta enabled flag
         * @param {UpdateBetaEnabledDTO} updateBetaEnabledDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBetaEnabled(updateBetaEnabledDTO: UpdateBetaEnabledDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDTO> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).updateBetaEnabled(updateBetaEnabledDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update a user\'s email settings
         * @param {UpdateUserEmailSettingsDTO} updateUserEmailSettingsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailSettings(updateUserEmailSettingsDTO: UpdateUserEmailSettingsDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDTO> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).updateEmailSettings(updateUserEmailSettingsDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update the authenticated tenant\'s marketing preferences
         * @param {UpdateMarketingPreferencesDTO} updateMarketingPreferencesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMarketingPreferences(updateMarketingPreferencesDTO: UpdateMarketingPreferencesDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketingPreferencesDTO> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).updateMarketingPreferences(updateMarketingPreferencesDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update a User
         * @param {string} id 
         * @param {UpdateUserDTO} updateUserDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(id: string, updateUserDTO: UpdateUserDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDTO> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).updateUser(id, updateUserDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Complete onboarding introduction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeOnboardingIntroduction(options?: any) {
            return UsersApiFp(configuration).completeOnboardingIntroduction(options)(axios, basePath);
        },
        /**
         * Create a one time session token to transfer a users session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneTimeSessionToken(options?: any) {
            return UsersApiFp(configuration).createOneTimeSessionToken(options)(axios, basePath);
        },
        /**
         * Dismiss new product updates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissNewProductUpdates(options?: any) {
            return UsersApiFp(configuration).dismissNewProductUpdates(options)(axios, basePath);
        },
        /**
         * Dismiss a user message
         * @param {'featureClaimUploads' | 'marketingMessageSwitchApril2023' | 'minimumRepositPricingMarch2024' | 'partnerDashboardBetaWelcome' | 'partnerEOTChasersWelcome'} messageId Message id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissUserMessage(messageId: 'featureClaimUploads' | 'marketingMessageSwitchApril2023' | 'minimumRepositPricingMarch2024' | 'partnerDashboardBetaWelcome' | 'partnerEOTChasersWelcome', options?: any) {
            return UsersApiFp(configuration).dismissUserMessage(messageId, options)(axios, basePath);
        },
        /**
         * Get a User by id
         * @param {string} id User id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneByID(id: string, options?: any) {
            return UsersApiFp(configuration).findOneByID(id, options)(axios, basePath);
        },
        /**
         * Get a customer by userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomer(options?: any) {
            return UsersApiFp(configuration).getCustomer(options)(axios, basePath);
        },
        /**
         * Get the authenticated tenant\'s marketing preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketingPreferences(options?: any) {
            return UsersApiFp(configuration).getMarketingPreferences(options)(axios, basePath);
        },
        /**
         * Get a User\'s Organizations
         * @param {string} id User id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationUsers(id: string, options?: any) {
            return UsersApiFp(configuration).getOrganizationUsers(id, options)(axios, basePath);
        },
        /**
         * Get a users tenancy orders by productId
         * @param {string} productId ProductId to filter tenancy orders by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenancyOrdersByProductId(productId: string, options?: any) {
            return UsersApiFp(configuration).getTenancyOrdersByProductId(productId, options)(axios, basePath);
        },
        /**
         * Get the authenticated users account info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAccount(options?: any) {
            return UsersApiFp(configuration).getUserAccount(options)(axios, basePath);
        },
        /**
         * Get a users tenancy anniversaries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTenancyAnniversaries(options?: any) {
            return UsersApiFp(configuration).getUserTenancyAnniversaries(options)(axios, basePath);
        },
        /**
         * Get the authenticated user info, organizations and reposit stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        me(options?: any) {
            return UsersApiFp(configuration).me(options)(axios, basePath);
        },
        /**
         * Send an Agent, Landlord or Tenant a reset password email
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserPassword(id: string, options?: any) {
            return UsersApiFp(configuration).resetUserPassword(id, options)(axios, basePath);
        },
        /**
         * Search for a User by name or email
         * @param {string} userTypeId User type Id to filter to by
         * @param {number} page Page to start on (defaults to 1)
         * @param {number} size Size of result set to return (defaults to 15)
         * @param {string} [query] Search query
         * @param {string} [sortBy] Sort By to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUser(userTypeId: string, page: number, size: number, query?: string, sortBy?: string, options?: any) {
            return UsersApiFp(configuration).searchUser(userTypeId, page, size, query, sortBy, options)(axios, basePath);
        },
        /**
         * Update a users about me via onboarding
         * @param {UpdateUserAboutMeDTO} updateUserAboutMeDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAboutMe(updateUserAboutMeDTO: UpdateUserAboutMeDTO, options?: any) {
            return UsersApiFp(configuration).updateAboutMe(updateUserAboutMeDTO, options)(axios, basePath);
        },
        /**
         * Update a users address history via onboarding
         * @param {UpdateUserAddressHistoryDTO} updateUserAddressHistoryDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAddressHistory(updateUserAddressHistoryDTO: UpdateUserAddressHistoryDTO, options?: any) {
            return UsersApiFp(configuration).updateAddressHistory(updateUserAddressHistoryDTO, options)(axios, basePath);
        },
        /**
         * Update beta enabled flag
         * @param {UpdateBetaEnabledDTO} updateBetaEnabledDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBetaEnabled(updateBetaEnabledDTO: UpdateBetaEnabledDTO, options?: any) {
            return UsersApiFp(configuration).updateBetaEnabled(updateBetaEnabledDTO, options)(axios, basePath);
        },
        /**
         * Update a user\'s email settings
         * @param {UpdateUserEmailSettingsDTO} updateUserEmailSettingsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailSettings(updateUserEmailSettingsDTO: UpdateUserEmailSettingsDTO, options?: any) {
            return UsersApiFp(configuration).updateEmailSettings(updateUserEmailSettingsDTO, options)(axios, basePath);
        },
        /**
         * Update the authenticated tenant\'s marketing preferences
         * @param {UpdateMarketingPreferencesDTO} updateMarketingPreferencesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMarketingPreferences(updateMarketingPreferencesDTO: UpdateMarketingPreferencesDTO, options?: any) {
            return UsersApiFp(configuration).updateMarketingPreferences(updateMarketingPreferencesDTO, options)(axios, basePath);
        },
        /**
         * Update a User
         * @param {string} id 
         * @param {UpdateUserDTO} updateUserDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(id: string, updateUserDTO: UpdateUserDTO, options?: any) {
            return UsersApiFp(configuration).updateUser(id, updateUserDTO, options)(axios, basePath);
        },
    };
};

/**
 * UsersApi - interface
 * @export
 * @interface UsersApi
 */
export interface UsersApiInterface {
    /**
     * Complete onboarding introduction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    completeOnboardingIntroduction(options?: any): AxiosPromise<UserDTO>;

    /**
     * Create a one time session token to transfer a users session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    createOneTimeSessionToken(options?: any): AxiosPromise<OneTimeSessionTokenDTO>;

    /**
     * Dismiss new product updates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    dismissNewProductUpdates(options?: any): AxiosPromise<UserDTO>;

    /**
     * Dismiss a user message
     * @param {'featureClaimUploads' | 'marketingMessageSwitchApril2023' | 'minimumRepositPricingMarch2024' | 'partnerDashboardBetaWelcome' | 'partnerEOTChasersWelcome'} messageId Message id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    dismissUserMessage(messageId: 'featureClaimUploads' | 'marketingMessageSwitchApril2023' | 'minimumRepositPricingMarch2024' | 'partnerDashboardBetaWelcome' | 'partnerEOTChasersWelcome', options?: any): AxiosPromise<UserDTO>;

    /**
     * Get a User by id
     * @param {string} id User id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    findOneByID(id: string, options?: any): AxiosPromise<UserDTO>;

    /**
     * Get a customer by userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getCustomer(options?: any): AxiosPromise<CustomerDTO>;

    /**
     * Get the authenticated tenant\'s marketing preferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getMarketingPreferences(options?: any): AxiosPromise<MarketingPreferencesDTO>;

    /**
     * Get a User\'s Organizations
     * @param {string} id User id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getOrganizationUsers(id: string, options?: any): AxiosPromise<Array<OrganizationUserDTO>>;

    /**
     * Get a users tenancy orders by productId
     * @param {string} productId ProductId to filter tenancy orders by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getTenancyOrdersByProductId(productId: string, options?: any): AxiosPromise<Array<TenancyOrderWithTenancyAndOrderCustomersDTO>>;

    /**
     * Get the authenticated users account info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getUserAccount(options?: any): AxiosPromise<CurrentUserAccountInfoDTO>;

    /**
     * Get a users tenancy anniversaries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getUserTenancyAnniversaries(options?: any): AxiosPromise<Array<TenancyAnniversaryWithTenancyDTO>>;

    /**
     * Get the authenticated user info, organizations and reposit stats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    me(options?: any): AxiosPromise<CurrentUserInfoDTO>;

    /**
     * Send an Agent, Landlord or Tenant a reset password email
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    resetUserPassword(id: string, options?: any): AxiosPromise<object>;

    /**
     * Search for a User by name or email
     * @param {string} userTypeId User type Id to filter to by
     * @param {number} page Page to start on (defaults to 1)
     * @param {number} size Size of result set to return (defaults to 15)
     * @param {string} [query] Search query
     * @param {string} [sortBy] Sort By to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    searchUser(userTypeId: string, page: number, size: number, query?: string, sortBy?: string, options?: any): AxiosPromise<SearchUserResultsDTO>;

    /**
     * Update a users about me via onboarding
     * @param {UpdateUserAboutMeDTO} updateUserAboutMeDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    updateAboutMe(updateUserAboutMeDTO: UpdateUserAboutMeDTO, options?: any): AxiosPromise<UserDTO>;

    /**
     * Update a users address history via onboarding
     * @param {UpdateUserAddressHistoryDTO} updateUserAddressHistoryDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    updateAddressHistory(updateUserAddressHistoryDTO: UpdateUserAddressHistoryDTO, options?: any): AxiosPromise<UserDTO>;

    /**
     * Update beta enabled flag
     * @param {UpdateBetaEnabledDTO} updateBetaEnabledDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    updateBetaEnabled(updateBetaEnabledDTO: UpdateBetaEnabledDTO, options?: any): AxiosPromise<UserDTO>;

    /**
     * Update a user\'s email settings
     * @param {UpdateUserEmailSettingsDTO} updateUserEmailSettingsDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    updateEmailSettings(updateUserEmailSettingsDTO: UpdateUserEmailSettingsDTO, options?: any): AxiosPromise<UserDTO>;

    /**
     * Update the authenticated tenant\'s marketing preferences
     * @param {UpdateMarketingPreferencesDTO} updateMarketingPreferencesDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    updateMarketingPreferences(updateMarketingPreferencesDTO: UpdateMarketingPreferencesDTO, options?: any): AxiosPromise<MarketingPreferencesDTO>;

    /**
     * Update a User
     * @param {string} id 
     * @param {UpdateUserDTO} updateUserDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    updateUser(id: string, updateUserDTO: UpdateUserDTO, options?: any): AxiosPromise<UserDTO>;

}

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI implements UsersApiInterface {
    /**
     * Complete onboarding introduction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public completeOnboardingIntroduction(options?: any) {
        return UsersApiFp(this.configuration).completeOnboardingIntroduction(options)(this.axios, this.basePath);
    }

    /**
     * Create a one time session token to transfer a users session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public createOneTimeSessionToken(options?: any) {
        return UsersApiFp(this.configuration).createOneTimeSessionToken(options)(this.axios, this.basePath);
    }

    /**
     * Dismiss new product updates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public dismissNewProductUpdates(options?: any) {
        return UsersApiFp(this.configuration).dismissNewProductUpdates(options)(this.axios, this.basePath);
    }

    /**
     * Dismiss a user message
     * @param {'featureClaimUploads' | 'marketingMessageSwitchApril2023' | 'minimumRepositPricingMarch2024' | 'partnerDashboardBetaWelcome' | 'partnerEOTChasersWelcome'} messageId Message id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public dismissUserMessage(messageId: 'featureClaimUploads' | 'marketingMessageSwitchApril2023' | 'minimumRepositPricingMarch2024' | 'partnerDashboardBetaWelcome' | 'partnerEOTChasersWelcome', options?: any) {
        return UsersApiFp(this.configuration).dismissUserMessage(messageId, options)(this.axios, this.basePath);
    }

    /**
     * Get a User by id
     * @param {string} id User id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public findOneByID(id: string, options?: any) {
        return UsersApiFp(this.configuration).findOneByID(id, options)(this.axios, this.basePath);
    }

    /**
     * Get a customer by userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getCustomer(options?: any) {
        return UsersApiFp(this.configuration).getCustomer(options)(this.axios, this.basePath);
    }

    /**
     * Get the authenticated tenant\'s marketing preferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getMarketingPreferences(options?: any) {
        return UsersApiFp(this.configuration).getMarketingPreferences(options)(this.axios, this.basePath);
    }

    /**
     * Get a User\'s Organizations
     * @param {string} id User id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getOrganizationUsers(id: string, options?: any) {
        return UsersApiFp(this.configuration).getOrganizationUsers(id, options)(this.axios, this.basePath);
    }

    /**
     * Get a users tenancy orders by productId
     * @param {string} productId ProductId to filter tenancy orders by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getTenancyOrdersByProductId(productId: string, options?: any) {
        return UsersApiFp(this.configuration).getTenancyOrdersByProductId(productId, options)(this.axios, this.basePath);
    }

    /**
     * Get the authenticated users account info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUserAccount(options?: any) {
        return UsersApiFp(this.configuration).getUserAccount(options)(this.axios, this.basePath);
    }

    /**
     * Get a users tenancy anniversaries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUserTenancyAnniversaries(options?: any) {
        return UsersApiFp(this.configuration).getUserTenancyAnniversaries(options)(this.axios, this.basePath);
    }

    /**
     * Get the authenticated user info, organizations and reposit stats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public me(options?: any) {
        return UsersApiFp(this.configuration).me(options)(this.axios, this.basePath);
    }

    /**
     * Send an Agent, Landlord or Tenant a reset password email
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public resetUserPassword(id: string, options?: any) {
        return UsersApiFp(this.configuration).resetUserPassword(id, options)(this.axios, this.basePath);
    }

    /**
     * Search for a User by name or email
     * @param {string} userTypeId User type Id to filter to by
     * @param {number} page Page to start on (defaults to 1)
     * @param {number} size Size of result set to return (defaults to 15)
     * @param {string} [query] Search query
     * @param {string} [sortBy] Sort By to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public searchUser(userTypeId: string, page: number, size: number, query?: string, sortBy?: string, options?: any) {
        return UsersApiFp(this.configuration).searchUser(userTypeId, page, size, query, sortBy, options)(this.axios, this.basePath);
    }

    /**
     * Update a users about me via onboarding
     * @param {UpdateUserAboutMeDTO} updateUserAboutMeDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateAboutMe(updateUserAboutMeDTO: UpdateUserAboutMeDTO, options?: any) {
        return UsersApiFp(this.configuration).updateAboutMe(updateUserAboutMeDTO, options)(this.axios, this.basePath);
    }

    /**
     * Update a users address history via onboarding
     * @param {UpdateUserAddressHistoryDTO} updateUserAddressHistoryDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateAddressHistory(updateUserAddressHistoryDTO: UpdateUserAddressHistoryDTO, options?: any) {
        return UsersApiFp(this.configuration).updateAddressHistory(updateUserAddressHistoryDTO, options)(this.axios, this.basePath);
    }

    /**
     * Update beta enabled flag
     * @param {UpdateBetaEnabledDTO} updateBetaEnabledDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateBetaEnabled(updateBetaEnabledDTO: UpdateBetaEnabledDTO, options?: any) {
        return UsersApiFp(this.configuration).updateBetaEnabled(updateBetaEnabledDTO, options)(this.axios, this.basePath);
    }

    /**
     * Update a user\'s email settings
     * @param {UpdateUserEmailSettingsDTO} updateUserEmailSettingsDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateEmailSettings(updateUserEmailSettingsDTO: UpdateUserEmailSettingsDTO, options?: any) {
        return UsersApiFp(this.configuration).updateEmailSettings(updateUserEmailSettingsDTO, options)(this.axios, this.basePath);
    }

    /**
     * Update the authenticated tenant\'s marketing preferences
     * @param {UpdateMarketingPreferencesDTO} updateMarketingPreferencesDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateMarketingPreferences(updateMarketingPreferencesDTO: UpdateMarketingPreferencesDTO, options?: any) {
        return UsersApiFp(this.configuration).updateMarketingPreferences(updateMarketingPreferencesDTO, options)(this.axios, this.basePath);
    }

    /**
     * Update a User
     * @param {string} id 
     * @param {UpdateUserDTO} updateUserDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateUser(id: string, updateUserDTO: UpdateUserDTO, options?: any) {
        return UsersApiFp(this.configuration).updateUser(id, updateUserDTO, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for UsersApi
 * Import individual functions for optimal bundle size
 */
/**
 * Complete onboarding introduction
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function completeOnboardingIntroduction(
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<UserDTO> {
    const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).completeOnboardingIntroduction(options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Create a one time session token to transfer a users session
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function createOneTimeSessionToken(
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OneTimeSessionTokenDTO> {
    const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).createOneTimeSessionToken(options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Dismiss new product updates
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function dismissNewProductUpdates(
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<UserDTO> {
    const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).dismissNewProductUpdates(options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Dismiss a user message
 * @param {'featureClaimUploads' | 'marketingMessageSwitchApril2023' | 'minimumRepositPricingMarch2024' | 'partnerDashboardBetaWelcome' | 'partnerEOTChasersWelcome'} messageId Message id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function dismissUserMessage(
    messageId: 'featureClaimUploads' | 'marketingMessageSwitchApril2023' | 'minimumRepositPricingMarch2024' | 'partnerDashboardBetaWelcome' | 'partnerEOTChasersWelcome',
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<UserDTO> {
    const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).dismissUserMessage(messageId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get a User by id
 * @param {string} id User id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function findOneByID(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<UserDTO> {
    const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).findOneByID(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get a customer by userId
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getCustomer(
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<CustomerDTO> {
    const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).getCustomer(options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get the authenticated tenant\'s marketing preferences
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getMarketingPreferences(
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<MarketingPreferencesDTO> {
    const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).getMarketingPreferences(options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get a User\'s Organizations
 * @param {string} id User id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getOrganizationUsers(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<OrganizationUserDTO>> {
    const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).getOrganizationUsers(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get a users tenancy orders by productId
 * @param {string} productId ProductId to filter tenancy orders by
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getTenancyOrdersByProductId(
    productId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<TenancyOrderWithTenancyAndOrderCustomersDTO>> {
    const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).getTenancyOrdersByProductId(productId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get the authenticated users account info
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getUserAccount(
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<CurrentUserAccountInfoDTO> {
    const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).getUserAccount(options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get a users tenancy anniversaries
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getUserTenancyAnniversaries(
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<TenancyAnniversaryWithTenancyDTO>> {
    const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).getUserTenancyAnniversaries(options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get the authenticated user info, organizations and reposit stats
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function me(
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<CurrentUserInfoDTO> {
    const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).me(options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Send an Agent, Landlord or Tenant a reset password email
 * @param {string} id 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function resetUserPassword(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).resetUserPassword(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Search for a User by name or email
 * @param {string} userTypeId User type Id to filter to by
 * @param {number} page Page to start on (defaults to 1)
 * @param {number} size Size of result set to return (defaults to 15)
 * @param {string} [query] Search query
 * @param {string} [sortBy] Sort By to filter by
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function searchUser(
    userTypeId: string,
    page: number,
    size: number,
    query?: string,
    sortBy?: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<SearchUserResultsDTO> {
    const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).searchUser(userTypeId, page, size, query, sortBy, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update a users about me via onboarding
 * @param {UpdateUserAboutMeDTO} updateUserAboutMeDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateAboutMe(
    updateUserAboutMeDTO: UpdateUserAboutMeDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<UserDTO> {
    const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).updateAboutMe(updateUserAboutMeDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update a users address history via onboarding
 * @param {UpdateUserAddressHistoryDTO} updateUserAddressHistoryDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateAddressHistory(
    updateUserAddressHistoryDTO: UpdateUserAddressHistoryDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<UserDTO> {
    const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).updateAddressHistory(updateUserAddressHistoryDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update beta enabled flag
 * @param {UpdateBetaEnabledDTO} updateBetaEnabledDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateBetaEnabled(
    updateBetaEnabledDTO: UpdateBetaEnabledDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<UserDTO> {
    const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).updateBetaEnabled(updateBetaEnabledDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update a user\'s email settings
 * @param {UpdateUserEmailSettingsDTO} updateUserEmailSettingsDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateEmailSettings(
    updateUserEmailSettingsDTO: UpdateUserEmailSettingsDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<UserDTO> {
    const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).updateEmailSettings(updateUserEmailSettingsDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update the authenticated tenant\'s marketing preferences
 * @param {UpdateMarketingPreferencesDTO} updateMarketingPreferencesDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateMarketingPreferences(
    updateMarketingPreferencesDTO: UpdateMarketingPreferencesDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<MarketingPreferencesDTO> {
    const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).updateMarketingPreferences(updateMarketingPreferencesDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update a User
 * @param {string} id 
 * @param {UpdateUserDTO} updateUserDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateUser(
    id: string,
    updateUserDTO: UpdateUserDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<UserDTO> {
    const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).updateUser(id, updateUserDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

